export default __webpack_public_path__ + "static/media/web.122afa8b.svg";